import { Theme, configBase } from "../../utils/theme";

export async function listCustomThemes(id: string): Promise<Theme[] | null> {
  const themes: Partial<Theme>[] = await fetch(new URL(`/themes/${id}.json`, configBase).href, {
    cache: "no-cache"
  }).then(response => response.status === 403 ? [] : response.json());

  return themes.map(theme => new Theme(theme));
}

/**
 * Returns a list of common themes.
 */
export async function listThemes(): Promise<Theme[]> {
  const testThemes = localStorage.getItem('testThemes');
  if (testThemes) {
    try {
      return JSON.parse(testThemes).map((theme: Partial<Theme>) => new Theme(theme));
    } catch (error) {
      console.error(error);
      alert("Kunde inte läsa in testThemes från localStorage: " + JSON.stringify({
        ...error,
        name: error.name,
        message: error.message,
      }))
    }
  }

  const themes: Partial<Theme>[] = await fetch(new URL('/themes/common.json', configBase).href, {
    cache: "no-cache"
  }).then(response => response.json());

  return themes.map(theme => new Theme(theme));
}